import ajax from '@/utils/ajax'

/**
 * @module 消息管理接口
 */

 const BASE_URL = '/messageCenter/messageNewManage'

// 获取分页获取站内信
export const getLetterListWithPge = (params) => ajax.post(`${BASE_URL}/getLetterListWithPge`, params)

// 全部已读接口
export const readAll = (params) => ajax.post(`${BASE_URL}/readAll`, params)

// 详情
export const readAndGetOne = (params) => ajax.post(`${BASE_URL}/readAndGetOne`, params)

// 消息类型下拉框接口
export const getMsgTypeList = (params) => ajax.post(`/messageCenter/common/getMsgTypeList`, params)

// 查询增长计划活动详情
export const getActivityDetail = (params) => ajax({
  url: '/merchantMarket/detailNew',
  method: 'post',
  params
})
